const DEVICE_ID_KEY = 'budget.deviceId';
const DEVICE_NAME_KEY = 'budget.deviceName';

/**
 * Identifiant d'appareil : engendré une fois par téléphone, conservé ensuite.
 * C'est lui qui permet d'attribuer une saisie sans imposer plusieurs comptes.
 */
export function getDeviceId(): string {
  const existing = localStorage.getItem(DEVICE_ID_KEY);
  if (existing !== null) return existing;

  const created = crypto.randomUUID();
  localStorage.setItem(DEVICE_ID_KEY, created);
  return created;
}

export function getDeviceName(): string {
  return localStorage.getItem(DEVICE_NAME_KEY) ?? suggestDeviceName();
}

export function setDeviceName(name: string): void {
  localStorage.setItem(DEVICE_NAME_KEY, name);
}

/** Proposition de départ, que l'utilisateur corrige à la connexion. */
function suggestDeviceName(): string {
  const agent = navigator.userAgent;
  if (/Android/i.test(agent)) return 'Téléphone Android';
  if (/iPhone|iPad/i.test(agent)) return 'iPhone';
  return 'Navigateur';
}
